module.exports = __webpack_public_path__ + "static/media/img_email.1e1c1ad7.svg";